import { useLocation } from "react-router-dom";

import { TUTORING_LEAD_SOURCES } from "@seneca/tutoring-service-consts";

import { getValueFromLinkState } from "seneca-common/utils/routing";

import { OneToOneTutoringSourceParamKey } from "features/parents/routes/parent/routes/tutoring-page/links";

export default function useGetTutoringLeadSource() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const queryParamSource = searchParams.get(
    OneToOneTutoringSourceParamKey
  ) as TUTORING_LEAD_SOURCES;

  const linkStateSource = getValueFromLinkState<TUTORING_LEAD_SOURCES>(
    location,
    "source"
  );

  return linkStateSource || queryParamSource || TUTORING_LEAD_SOURCES.UNSET;
}
